const buildPreviewMoviePayload = (values, cliCinemasIdList) => ({
    title: values.title.trim(),
    expectedStartDate: values.expectedStartDate || null,
    startDateDescription: values.startDateDescription.trim() || null,
    ...(cliCinemasIdList.length > 1 && {
        visibleIn: values.cinemasFilter.length === cliCinemasIdList.length ? null : values.cinemasFilter,
    }),
})

export default buildPreviewMoviePayload
